import { getResolution } from '@backmarket/http-api/src/api-specs-after-sale-experience/resolution-engine/endpoints'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

import {
  SALES_CUSTOMER_CARE_SCOPE,
  type SalesCustomerCareScope,
} from '~/scopes/care-commons/utils/logger/salesCustomerCare/config'
import { useSalesCustomerCareLogger } from '~/scopes/care-commons/utils/logger/salesCustomerCare/useSalesCustomerCareLogger'

export function useResolution({
  resolutionId,
  options = { immediate: true },
  scope = SALES_CUSTOMER_CARE_SCOPE.contactConfirmationPage,
}: {
  resolutionId: string
  options?: { immediate: boolean }
  scope?: SalesCustomerCareScope
}) {
  const { logHttpOnEvent } = useSalesCustomerCareLogger()

  return useHttpFetch(getResolution, {
    pathParams: {
      resolutionId,
    },
    ...options,
    onEvent: (event, context) =>
      logHttpOnEvent({
        event,
        context,
        errorTitle: `${scope} Error when fetching associated resolution for resolutionId:${resolutionId}`,
      }),
  })
}
